import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "@app/app.module";
import { environment } from "@app/environments/environment";

// Define interactClientContext interface and globally
interface InteractClientContext {
    marketingRegion: string;
    businessSegment: string;
    marketingPageId: string;
    internal: boolean;
}

declare global {
    interface Window {
        interactClientContext: InteractClientContext;
    }
}

window.interactClientContext = {
    marketingRegion: "NA",
    businessSegment: "COMMON",
    marketingPageId: "L1_TM",
    internal: false,
};

if (environment.production) {
    enableProdMode();
}

    platformBrowserDynamic()
        .bootstrapModule(AppModule)
        .catch((err) => console.error(err));
